import { render, staticRenderFns } from "./HTicaret.vue?vue&type=template&id=c63d33da&scoped=true&"
import script from "./HTicaret.vue?vue&type=script&lang=js&"
export * from "./HTicaret.vue?vue&type=script&lang=js&"
import style0 from "./HTicaret.vue?vue&type=style&index=0&id=c63d33da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c63d33da",
  null
  
)

export default component.exports